import { CANTRATE_ID } from '@webapp/common/resources/constants';
import type { PerceptionTextItem } from '@webapp/common/resources/question';

import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class TextPerceptionApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const {
            id,
            responseActor,
            params: { perceptionText },
        } = actor.getSnapshot().context;
        const { comment, value } = responseActor.getSnapshot().context;
        const data = [];

        if (value === CANTRATE_ID) {
            data.push({ cantRate: true });
        } else if (Array.isArray(value)) {
            let newItem = [];
            let prevPos: number;

            (value as unknown as Array<PerceptionTextItem>).forEach((item, index) => {
                if (
                    index === 0 ||
                    (item.pos - prevPos === 2 &&
                        perceptionText.find((item) => item.pos === prevPos + 1)?.isSelectable === false)
                ) {
                    newItem.push(item);
                    prevPos = item.pos;
                } else {
                    data.push({ json: newItem });
                    newItem = [];
                    newItem.push(item);
                    prevPos = item.pos;
                }

                if (index === value.length - 1) {
                    data.push({ json: newItem });
                }
            });
        }

        return {
            question: id,
            data,
            comment,
        };
    }

    public validate({ params: { required }, responseActor }: QuestionContext): boolean {
        const { value } = responseActor.getSnapshot().context;

        if (!required || value === CANTRATE_ID) return true;

        return Boolean(value) && (value as string).length > 0;
    }
}
